/* global Provider */
/* eslint no-useless-escape: "off" */
import React, { Component } from 'react';
import SimpleReactValidator from 'simple-react-validator';
import LogoGrpaa from '../img/grpaa-img-logo-wide.png';

class InitialPage extends Component {
    constructor(props){
        super(props);
        this.state = {
            firstName: null,
            firstNameValidation: null,
            lastName: null,
            email: null,
            company: null,
            phone: null,
            certified: null
        }

        this.submit = this.submit.bind(this);
		this.client = process.env.REACT_APP_CLIENT

		this.clientName = "American Century Investments"
		if (this.client === 'grpaa') this.clientName = "Viking Cove Advisor Alliance"

        this.validator = new SimpleReactValidator({
            validators: {
                name: {  // name the rule
                    message: 'The field contains invalid characters.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val,/^[A-Z0-9\s\-'\.]*$/i) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                company: {  // name the rule
                    message: 'The field contains invalid characters.',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val,/^[A-Z0-9\s\(\)\-\$\._\,\?\'\!\&\%\+\#\*']*$/i) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                }
            }
        });
    }

    submit(){
        if (!this.validator.allValid()) {
            this.validator.showMessages();
            this.forceUpdate();
            return;
        }

        if (!this.state.certified){
            Provider.showModal('Error', (
                <div>
                    Please certify that you are a licensed, financial professional and agree to these Terms &amp; Conditions of Use.
                </div>
            ));
            return;
        }

        this.props.setUserInfo(this.state);
    }

    render() {
        return (
            <div className="initial-page">
                <div className="container">
                    <div className="row header">
                        <div className="col-sm">
							{this.client === 'aci' && 
                          		<img data-assetid="39311" src="https://image.impact.americancentury.com/lib/fe37157075640475731c71/m/1/19579bd4-81c8-497e-b5e1-b9b4597a0d6a.png" height="58" width="260" alt="logo"/>
							}
							{this.client === 'grpaa' && 
								<img data-assetid="39311" src={LogoGrpaa} height="58" alt="logo"/>
							}
						</div>
                        <div className="col-sm text-right">
                            <a href="https://ipro.americancentury.com" target="_blank" rel="noopener noreferrer" title="Visit Us Online">Visit Us Online</a>
                        </div>
                    </div>
                    <hr />
                    <div className="row body">
                        <div className="col-sm-8">
                            <h1>
								{this.client === 'aci' && 
									<>American Century Target-Date Blueprint</>
								}
								{this.client === 'grpaa' && 
									<>Target-Date Blueprint</>
								}
                            </h1>
                            <h2>
                                Choosing the right TDF for each plan has never been more important:
                            </h2>
                            <ul>
                                <li>Increasing fiduciary requirements have created mounting challenges for plan sponsors.</li>
                                <li>Differences among Target‐Date Funds (TDFs)—in asset mixes, glide paths, and investment fees—can mean significant variations in performance.</li>
                                <li>Participant populations often vary from industry to industry and firm to firm—In demographics, savings levels and risk tolerance.</li>
                            </ul>
                            <p>
                                Against this backdrop, plan sponsors need knowledge and tools to help them make prudent TDF selection decisions.
                            </p>
                            <p>
                                To help plan sponsors navigate the complexities of TDF strategy evaluation and monitoring, the Department of Labor (DOL) has issued Tips for ERISA Plan Fiduciaries
                            </p>
                            <h2>
                                Target‐Date Blueprint provides a framework for aligning TDF selection with the DOL’s Tips for Plan Fiduciaries.    
                            </h2>
                            <img src="https://image.impact.americancentury.com/lib/fe37157075640475731c71/m/1/ed60ff97-92fb-4f0d-b2d8-d346f8b06195.png" width="100%" alt="tdf"></img>
                        </div>
                        <div className="col-sm-4">
                            <h1>Get Started</h1>
                            <span>Please complete the form below to enter the questionnaire</span>
                            <div className="form">
                                <div className="form-group">
                                    <input type="text" className="form-control" id="firstname" placeholder="First Name" onChange={(event) => {
                                        this.setState({ firstName: event.target.value });
                                    }} />
                                    {this.validator.message('First_Name', this.state.firstName, 'required|name|max:50')}
                                </div>    
                                <div className="form-group">                                
                                    <input type="text" className="form-control" id="lastname" placeholder="Last Name" onChange={(event) => {
                                        this.setState({ lastName: event.target.value });
                                    }}/>
                                    {this.validator.message('Last_Name', this.state.lastName, 'required|name|max:50')}
                                </div>                                                
                                <div className="form-group">
                                    <input type="email" className="form-control" id="email" placeholder="Business Email Address" onChange={(event) => {
                                        this.setState({ email: event.target.value });
                                    }} />
                                    {this.validator.message('Email', this.state.email, 'required|email|max:100')}
                                </div>
                                <div className="form-group">
                                    <input type="text" className="form-control" id="company" placeholder="Company" onChange={(event) => {
                                        this.setState({ company: event.target.value });
                                    }}/>
                                    {this.validator.message('Company', this.state.company, 'required|company|max:50')}
                                </div>     
                                <div className="form-group">
                                    <input type="text" className="form-control" id="phone" placeholder="Business Phone Numbers" onChange={(event) => {
                                        this.setState({ phone: event.target.value });
                                    }}/>
                                    {this.validator.message('Phone_Number', this.state.phone, 'required|phone')}
                                    <small className="form-text text-muted">Do not include an extension.</small>
                                </div>  
                                <div className="form-group check-group">
                                    <input type="checkbox" className="custom-control-input" id="certify" onChange={(event) => {
                                        this.setState({ certified: event.target.checked });
                                    }}/>
                                    <label className="custom-control-label" htmlFor="certify">I certify that I am a licensed, financial professional and agree to these&nbsp; 
                                    <a href="https://ipro.americancentury.com/content/ipro/en/legal/important-legal-information.html">Terms &amp; Conditions of Use</a></label>
                                </div> 
                                <div className="text-center">
                                    <button className="btn btn-success" onClick={this.submit}>Get Started</button>
                                    <p>
                                        By submitting you acknowledge to receiving communication from {this.clientName} and that the above information is accurate.
                                    </p>
                                </div>    
                            </div>                                                                                   
                        </div>
                    </div>
                    <hr />
                    <div className="row footer">
                        <p>
                            For Financial Professional Use Only/Not for distribution to the public
                        </p>
                        <p>
                            This material has been prepared for educational purposes only and is not intended as a personalized recommendation or fiduciary advice. 
                            It is not intended to provide, and should not be relied upon for, investment, accounting, legal or tax advice. 
                            Read about our <a href="https://ipro.americancentury.com/en/legal/privacy-and-security.html">Privacy &amp; Security</a> policies.
                        </p>
						{this.client === 'aci' && 
							<p>
								American Century Investment Services, Inc., Distributor<br/>
								© 2020 American Century Proprietary Holdings, Inc. All rights reserved.
							</p>
						}
						{this.client === 'grpaa' && 
							<p>
								© 2022 Viking Advisor Alliance. All rights reserved.
							</p>
						}
                    </div>
                </div>
            </div>
        );
    }
}

export default InitialPage;